import { createFileRoute } from '@tanstack/react-router'
import Contact from '../pages/Contact/Contact'
import PublicLayout from '../layouts/PublicLayout'

export const Route = createFileRoute('/contact')({
  component: ContactComponent,
})

function ContactComponent() {
  return (
    <PublicLayout>
      <Contact />
    </PublicLayout>
  )
}
